import React from 'react'
import seta from './images/seta-esquerda.png'
export const SetaEsquerda = (props) => <img src={seta} alt="Voltar" {...props} />
